import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { states } from "../../../reducers/queriesStates";
import ReportConstructrSwitcher from "./ReportConstructrSwitcher";
import ReportConstructorPaternList from "./ReportConstructorPaternList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import ReportContructorCustom from "./ReportContructorCustom";
import ReportConstructorCustomList from "./ReportConstructorCustomList";
import Preloader from "../../../shared/items/static/preloader";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import FormControl from "@mui/material/FormControl";

class ReportConstructorPatternField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { addCustomReportDahsboardDataState } = this.props;

    if (prevProps.addCustomReportDahsboardDataState === states.REQUEST && addCustomReportDahsboardDataState === states.READY) {
      this.setState({ fieldId: null });
    }
  }

  onChange(e) {
    this.setState({ fieldId: e.target.value });
  }

  onAdd() {
    const { selectedCustomReportId, onAddCustomReportField } = this.props;
    const { fieldId } = this.state;

    const options = { fieldId, reportId: selectedCustomReportId };

    onAddCustomReportField(options);
  }

  render() {
    const { fields, addCustomReportDahsboardDataState } = this.props;
    const { fieldId } = this.state;

    return (
      <div className={styles.reportConstructorPatternFieldsContainer}>
        <FormControl
          variant="standard"
          sx={{ m: 1, minWidth: 50, display: "inline-block", height: "30px" }}
          style={{ margin: "0px", padding: "3px" }}
        >
          <div>Доступные параметры:</div>
          <Select
            style={{ minWidth: "400px", margin: "0px" }}
            onChange={(e) => {
              this.onChange(e);
            }}
            placeholder={"Добавить колонку"}
            value={fieldId ?? ""}
          >
            {fields.map((x) => {
              return (
                <MenuItem key={x.id} value={x.id}>
                  {x.dashboard.title}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        {addCustomReportDahsboardDataState === states.REQUEST ? (
          <Preloader />
        ) : fieldId != null ? (
          <div className={styles.addToCustomReportBtnContainer}>
            <ButtonPrimary
              disabled={addCustomReportDahsboardDataState === states.REQUEST}
              handleClick={() => {
                this.onAdd();
              }}
              title="Добавить в отчет"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportConstructorPatternField)));
